import { useRef, useState } from 'react';

import { PASSWORD_MIN_LENGTH } from '@adflow/shared/util-superstruct';

import type { InputTextFieldWithControlProps } from './InputTextFieldWithControl';
import { InputTextFieldWithControl } from './InputTextFieldWithControl';
import { VisibilityToggle } from './VisibilityToggle';

type PasswordInputProps = Pick<
	InputTextFieldWithControlProps,
	| 'labelStyle'
	| 'outerStyle'
	| 'label'
	| 'autoFocus'
	| 'forceAutoComplete'
	| 'disablePasswordManager'
	| 'readOnly'
	| 'archived'
	| 'placeholder'
	| 'name'
>;

export function PasswordInput(props: PasswordInputProps) {
	const [passwordShown, setPasswordShown] = useState(false);

	const inputRef = useRef<HTMLInputElement>(null);

	return (
		<InputTextFieldWithControl
			{...props}
			type={passwordShown ? 'text' : 'password'}
			endAdornment={
				<VisibilityToggle
					visible={passwordShown}
					setVisible={setPasswordShown}
					inputRef={inputRef}
				/>
			}
			context={{ minLength: PASSWORD_MIN_LENGTH }}
			autoComplete="new-password"
			ref={inputRef}
			data-clarity-mask="true"
			data-sentry-mask="true"
		/>
	);
}
